import { Repository } from '../../../core/context/repository';
import { type ThreatPath } from './entity';

export class ThreatPaths extends Repository<ThreatPath> {}
